module.exports = __webpack_public_path__ + "static/media/blinking.86107db0.gif";